import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { flashMessage as flash } from "../../../utils/flash";
import dashService from "./dashService";

// Initialize state
const initialState = {
  stat: null,
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
  loggedInUsers: null
};

// Get dashboard details
export const getDashStats = createAsyncThunk(
  "dash/getAll",
  async (data, thunkAPI) => {
    try {
      return await dashService.getDashStats(data);
    } catch (error) {
      const message = error.response.data.error;
      // const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString() || error.response.data.error.toString()
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getLoggedInUsers = createAsyncThunk(
  "dash/getLoggedInUsers",
  async (data, thunkAPI) => {
    try {
      return await dashService.getLoggedInUsers(data);
    } catch (error) {
      const message = error.response.data.error;
      // const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString() || error.response.data.error.toString()
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const dashSlice = createSlice({
  name: "dash",
  initialState,
  reducers: {
    reset(state) {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = false;
      state.message = "";
    },
    // resetState: (state) => {
    //     state = undefined
    // },
    resetDash: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDashStats.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDashStats.fulfilled, (state, action) => {
        if (action.payload.errors) {
          state.isLoading = false;
          state.isError = true;
          flash("error", action.payload.errors);
          return;
        }
        state.isLoading = false;
        state.isSuccess = true;
        state.stat = action.payload;
      })
      .addCase(getDashStats.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload);
      })
      .addCase(getLoggedInUsers.pending, (state) => {
        state.isLoading = true;
      }
      )
      .addCase(getLoggedInUsers.fulfilled, (state, action) => {
        if (action.payload.errors) {
          state.isLoading = false;
          state.isError = true;
          flash("error", action.payload.errors);
          return;
        }
        state.isLoading = false;
        state.isSuccess = true;
        state.loggedInUsers = action.payload;
      })
      .addCase(getLoggedInUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload);
      });
  },
});

export const { reset, resetDash } = dashSlice.actions;

export default dashSlice.reducer;
